import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { GET_VISITS_FAILURE, GET_VISITS_REQUEST, GET_VISITS_SUCCESS } from '../constants/visits.constants';

// Get visit
const getVisitsRequest = () => {
    return {
        type: GET_VISITS_REQUEST,
    };
};

const getVisitsSuccess = (staffData: AnyIfEmpty<object>) => {
    return {
        type: GET_VISITS_SUCCESS,
        payload: staffData,
    };
};

const getVisitsFailure = (staffError: string) => {
    return {
        type: GET_VISITS_FAILURE,
        payload: staffError,
    };
};

// Get visit Dispatch
export const getVisits = (location: string, startDate: string, endDate: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getVisitsRequest());
        return await axios
            .get(`/admin/appointments`, {
                params: {
                    location,
                    startDate,
                    endDate,
                },
                headers: {
                    'x-internal-api': 'true',
                },
            })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getVisitsSuccess(response.data));
                } else {
                    throw new Error(response.data.message);
                }
            })
            .catch((error) => dispatch(getVisitsFailure(error)));
    };
};

// Get Staff Dispatch
export const deleteVisits = (id: string, locationId: string, reason: string, startDate: string, endDate: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getVisitsRequest());
        return await axios
            .delete(`/admin/appointments/${id}`, {
                data: { reason: reason },
                headers: {
                    'x-internal-api': 'true',
                },
            })
            .then(() => {
                dispatch(getVisits(locationId, startDate, endDate));
            })
            .catch((error) => console.log(error));
    };
};
